import { listTriggers as publicListTriggers } from './ecom-custom-trigger-v1-custom-trigger-discounts-custom-trigger.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const listTriggers: MaybeContext<
  BuildRESTFunction<typeof publicListTriggers> & typeof publicListTriggers
> = /*#__PURE__*/ createRESTModule(publicListTriggers);

export {
  CustomTrigger,
  GetEligibleTriggersRequest,
  LineItem,
  CatalogReference,
  TriggerToFilterBy,
  ShippingInfo,
  Address,
  GetEligibleTriggersResponse,
  EligibleTrigger,
  ListTriggersRequest,
  ListTriggersResponse,
  ListTriggersResponseCustomTrigger,
} from './ecom-custom-trigger-v1-custom-trigger-discounts-custom-trigger.universal.js';
